<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_system_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="メールメッセージ（詳細）" >
            <div>
            </div>
          </title-and-slot>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
                            <button class="btn btn-primary" style="min-width:100px;float: left;margin-left: -10px;" @click="backToList" >＜　戻る</button>
            </div>
          </div>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-12" style="">
              <!-- Coll A -->
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>

          </div>
          <div class="col-xs-12" style="">
          <div class="row" style="margin-bottom:10px;" v-show="loading==false">

              <button v-if="read_only == false"  class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;margin-right:-10px;background: #92D050;border-color:#92D050;"  @click="onSave" >登録</button>
              <button
              :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
              v-if="read_only == true" class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;margin-right:-10px;" @click="onEdit"  >編集</button>
              <button v-if="read_only == false" :disabled="false" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #A6A6A6;border-color:#A6A6A6;" @click="btnCancel" >キャンセル</button>
              <button
              :disabled="checkUserPermission(true,permissionMode.DELETE) == false"
              v-if="read_only == true" class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete" >削除</button>
              <button
              :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
              v-if="read_only == true" class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;margin-right:5px;" @click="onGoToSendMail" >メール作成</button>
          </div>
          </div>
      </div>
      <confirmation-modal tag="deleteMailMessageDetailModal" @done="onConfirmDelete" />
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_mail_message';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:mail_message');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
  },
  data() {
    return {
      api_name:"mail_message",
      page_acl: acl.master,
      loading:true
    };
  },
  computed: {
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
          utils.extend(fields.mail_message_number, {disabled: true , read_only:true,label_class:"col-xs-2 control-label esma_form_label",field_class:"col-xs-10"}),
          utils.extend(fields.mail_type, {label_class:"col-xs-2 control-label esma_form_label",field_class:"col-xs-10"}),
          utils.extend(fields.mail_subject, {label_class:"col-xs-2 control-label esma_form_label",field_class:"col-xs-10"}),
          utils.extend(fields.mail_content, {}),
        ],
      }
    }
  },
  methods: {
    onGoToSendMail(){
      window.sessionStorage.setItem("send_mail_subject",this.$store.state[this.stateCurrentEditing].mail_subject || this.$store.state[this.stateCurrentRow].mail_subject  )
      window.sessionStorage.setItem("send_mail_message",this.$store.state[this.stateCurrentEditing].mail_content || this.$store.state[this.stateCurrentRow].mail_content)
      window.sessionStorage.setItem("send_mail_destination","")
      return this.$router.push({ name: "page_0081_mail_message_create", params: {seq_id:this.$route.params.seq_id} });

    },
    onSave(){
      this.read_only = false;
      this.commonSaveInfo(this,this.api_name, {} );
    },
    onEdit(){
      mdebug("onEdit")
      this.commonOnEdit();
    },
    onDelete(){
      bus.$emit("deleteMailMessageDetailModal",{
        title: "削除",
        message: "メールメッセージの削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    btnCancel() {
      this.cancelCurrentSelection(true);
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        this.commonDelete(this);
      }
    },
    backToList(){
      return this.$router.push({ name: "page_0081_mail_message", params: {} });
    }
  },
  mounted() {
    this.loading = true;
    this.commonLoadRecord({},(err,result)=>{
      this.commonEditDeleteCmdHandler(this,()=>{
        this.loading = false;
      });
    })
  },
  beforeDestroy() {
  },
  beforeMount() {
  }
};

</script>
<style scoped>

input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0081_mail_message_detail.vue?00760eae